<ng-container *ngIf="viewToDisplay == 'download'">
    <p *ngIf="isChangingDeviceSetup == false">For security purposes your organisation
    needs you to set up a second method of authentication.</p>
    <br>
   <p>
    Please ensure you have an authentication app (such as Azure Authenticator or Google Authenticator) downloaded on your phone then click Next.
  </p>
    <div class="row margin-top-base">
        <div class="col-md-5 col-sm-5 col-md-offset-1 col col-xs-offset-1">
            <img [src]="appStoreImage"/>
        </div>
        <div class="col-md-5 col-sm-5 ">
            <img [src]="googlePlayImage"/>
        </div>
    </div>
    <div class="text-center margin-top-base padding-top-base">
        <a class="btn btn-primary btn-block" [ngStyle]="{'background-color': this.sharedService.ButtonColor.value, 'color':  this.sharedService.TextButtonColor.value}"
        (click)="getQRCode()">Next</a>
    </div>
</ng-container>

<ng-container *ngIf="viewToDisplay != 'download' && viewToDisplay != 'QRCode' && viewToDisplay != 'QRCodeForDeviceChange' || showLastVerificationCodeToLogin == true">
  <verify-code *ngIf="!showLastVerificationCodeToLogin" [isChangingDevice]="true" [showLastVerificationCodeToLogin]="showLastVerificationCodeToLogin"></verify-code>

  <div *ngIf="showLastVerificationCodeToLogin" class="card card-login">
    <div class="card-content">
      <div class="row" *ngIf="!removeLogo">
        <div class="container-fluid">
          <div class="login-header text-center">
            <img [src]="this.logoPath" class="logo" alt="able+" title="able+" />
            <h3>2-Step verification</h3>
          </div>
        </div>
      </div>
      <verify-code [isChangingDevice]="true" (logoHidden)="removeLogoFromView($event)" [showLastVerificationCodeToLogin]="showLastVerificationCodeToLogin"></verify-code>
    </div>
    <div class="footer text-center" *ngIf="!removeLogo">
      <p class="small">
        <a routerLink="/login" routerLinkActive="active">
          Sign in with a different account</a>
      </p>
    </div>
  </div>
</ng-container>

<!-- View for QR code scan -->
<ng-container *ngIf="viewToDisplay == 'QRCode'">
    <span>
        Scan this code with the <b>'Able+ Authentication'</b> app to link account and device
    </span>
    <br>
    <img *ngIf="this.QRCode" [src] = "this.QRCode" class="qr-code-image"/>
  <div class="text-center margin-top-base padding-top-base">
    <a class="btn btn-primary btn-block" [ngStyle]="{'background-color': this.sharedService.ButtonColor.value, 'color':  this.sharedService.TextButtonColor.value}"
       (click)="nextClicked()">Next</a>
  </div>

</ng-container>


<div class="card card-login" *ngIf="viewToDisplay == 'QRCodeForDeviceChange'">
  <div class="card-content">
    <div class="row">
      <div class="container-fluid">
        <div class="login-header text-center">
          <img [src]="this.logoPath" class="logo" alt="able+" title="able+" />
          <h3>2-Step verification</h3>
        </div>
      </div>
    </div>
    <ng-container>
    <span>
        Scan this code with the <b>'Able+ Authentication'</b> app to link account and device
    </span>
      <br>
      <img *ngIf="this.QRCode" [src]="this.QRCode" class="qr-code-image"/>
      <div class="text-center margin-top-base padding-top-base">
        <a class="btn btn-primary btn-block"
           [ngStyle]="{'background-color': this.sharedService.ButtonColor.value, 'color':  this.sharedService.TextButtonColor.value}"
           (click)="nextClicked()">Next</a>
      </div>

    </ng-container>
    </div>

  <div class="footer text-center">
    <p class="small">
      <a routerLink="/login" routerLinkActive="active">
        Sign in with a different account</a>
    </p>
  </div>
</div>
<!-- View for QR code scan end-->

<!-- View for Wait for confirm -->
<ng-container  *ngIf="viewToDisplay == 'confirmChange'">
    <p>{{msg}}</p>
</ng-container>
<!-- View for Wait for confirm end-->

